import getDateValue from './get-date-value';

export { getDateValue };

export default getDateValue;
